import { MediaQueriesTable } from '@af/design-system-docs-ui';
import SectionMessage from '@atlaskit/section-message';
import * as React from 'react';
export default {
  MediaQueriesTable,
  SectionMessage,
  React
};